import { appLog } from '@shared/common/logging/app-log.util';
import { BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxBootstrapLocaleMappingService } from '@assets/ngx-bootstrap/ngx-bootstrap-locale-mapping.service';
import { defineLocale } from 'ngx-bootstrap/chronos';
export class NgxBootstrapDatePickerConfigService {
    /** Maps ngx-bootstrap `chronos` package export keys (e.g. `deLocale`) from a locale slug (`de`, `en-gb`). */
    private static localeChronosExportKey(slug: string): string {
        const normalized = slug.toLowerCase().trim().replace(/_/g, '-');
        const camel = normalized.replace(/-([a-z])/g, (_: string, c: string) => c.toUpperCase());
        return camel.charAt(0).toLowerCase() + camel.slice(1) + 'Locale';
    }
    static getDaterangepickerConfig(): BsDaterangepickerConfig {
        return Object.assign(new BsDaterangepickerConfig(), {
            containerClass: 'theme-default'
        });
    }
    static getDatepickerConfig(): BsDatepickerConfig {
        return Object.assign(new BsDatepickerConfig(), {
            containerClass: 'theme-default'
        });
    }
    static getDatepickerLocale(): BsLocaleService {
        let localeService = new BsLocaleService();
        localeService.use(abp.localization.currentLanguage.name);
        return localeService;
    }
    static registerNgxBootstrapDatePickerLocales(): Promise<boolean> {
        if (abp.localization.currentLanguage.name === 'en') {
            return Promise.resolve(true);
        }
        const supportedLocale = new NgxBootstrapLocaleMappingService().map(abp.localization.currentLanguage.name).toLowerCase();
        return new Promise<boolean>((resolve, reject) => {
            import('ngx-bootstrap/chronos')
                .then((chronos: Record<string, unknown>) => {
                const exportKey = NgxBootstrapDatePickerConfigService.localeChronosExportKey(supportedLocale);
                const localeData = chronos[exportKey];
                if (!localeData) {
                    appLog.warn(`ngx-bootstrap chronos: no locale export "${exportKey}" for "${supportedLocale}"`);
                    resolve(true);
                    return;
                }
                defineLocale(abp.localization.currentLanguage.name.toLowerCase(), localeData as any);
                resolve(true);
            }, reject);
        });
    }
}
